module.exports = __webpack_public_path__ + "img/蒙版组 26.fd80b981.jpg";